<template>
  <div id="game_01">
    <div class="main">
      <div class="game_wrapper">
        <div class="game">
          <div class="field" :style="{ backgroundImage: `url(${publicPath}img/game/01/bg_game.png)`}">
            <div class="hearts">
              <div class="heart b1" data-num="1" :style="{ backgroundImage: `url(${publicPath}img/game/01/btn_a.png)`}"></div>
              <div class="heart b2" data-num="2" :style="{ backgroundImage: `url(${publicPath}img/game/01/btn_b.png)`}"></div>
              <div class="heart b3" data-num="3" :style="{ backgroundImage: `url(${publicPath}img/game/01/btn_c.png)`}"></div>
              <div class="heart b4" data-num="4" :style="{ backgroundImage: `url(${publicPath}img/game/01/btn_dummy.png)`}"></div>
              <div class="heart b5" data-num="5" :style="{ backgroundImage: `url(${publicPath}img/game/01/btn_dummy.png)`}"></div>
            </div>

            <div class="btns">
              <div class="btn x1" data-x="0"></div>
              <div class="btn x2" data-x="1"></div>
              <div class="btn x3" data-x="2"></div>
              <div class="btn x4" data-x="3"></div>
            </div>
          </div>

          <div class="volumes">
            <div class="volume left" :style="{ backgroundImage: `url(${publicPath}img/game/01/volume_left.gif)`}"></div>
            <div class="volume right" :style="{ backgroundImage: `url(${publicPath}img/game/01/volume_right.gif)`}"></div>
          </div>

          <div class="chara_area">
            <div class="chara hasaka" :style="{ backgroundImage: `url(${publicPath}img/game/01/chara_hasaka.png)`}"></div>
            <div class="chara fujiwara" :style="{ backgroundImage: `url(${publicPath}img/game/01/chara_fujiwara.png)`}"></div>
          </div>

          <div class="frames">
              <div class="frame">
                <div class="img" :style="{ backgroundImage: `url(${publicPath}img/game/01/frame.png)`}"></div>
              </div>
            </div>
        </div>
      </div>

      <div class="txt_wrapper">
        <div class="txt" :style="{ backgroundImage: `url(${publicPath}img/game/01/bg_txt.png)`}">
          <div class="title"></div>
          <div class="q_txt"></div>
          <div class="answer"></div>
          <div class="next" :style="{ backgroundImage: `url(${publicPath}img/game/01/icon_next.png)`}"></div>
        </div>
      </div>
    </div>

    <div class="result">
      <div class="correct">
        <div class="bar top" :style="{ backgroundImage: `url(${publicPath}img/common/correct_img02.gif)`}"></div>
        <div class="chara" :style="{ backgroundImage: `url(${publicPath}img/common/correct_img01.png)`}"></div>
        <div class="bar bottom" :style="{ backgroundImage: `url(${publicPath}img/common/correct_img02.gif)`}"></div>
      </div>
      <div class="next" :style="{ backgroundImage: `url(${publicPath}img/game/01/icon_next.png)`}"></div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    data() {
      return {
        // 変更不可 -------------------------
        publicPath: process.env.BASE_URL,
        // ---------------------------------
        state: {
          qCnt: 0, // 問題のページ数
          current: 0, // 現在の設問
        },
        q: [
          ['落ちてくるハートにタイミングを合わせて答えよう！','♩お前は言ったな 演じなくちゃ愛されない！！'],
          ['♩ありのままじゃ愛されない？.♩だから演じる？ 堅実？ それが現実？ ファッキン！','♩俺の演技は理想のスペック'],
          ['♩ファッションじゃねえからお着替え出来ねぇ','♩唯一無二この生き様 上を目指すアクションはやめねぇ'],
          ['♩本当はお前も叫びたいんだろ本音.♩演技で隠した臆病の権化','♩隠してばっかじゃわからねぇ Blue ass'],
          ['♩ヤメとくんだな無駄な抵抗！'],
        ],
        a: [
          'A♩その質問に今こそアンサー.B♩言っとくけどなそんなことないさー.C♩タイガーファイヤーサイバーファイバー',
          'A♩手に入れたいものすべてをゲッツ.B♩100%搾りたてフレッシュ.C♩いつか本物になる為のステップ',
          'A♩鳴らすぜでっけークラクション.B♩これが俺のノンフィクション.C♩体には気をつけようコンディション',
          'A♩駆け出さなきゃ掴めねぇ True LOVE.B♩ラスト５分ここで出すスルーパス.C♩教えてくれお前もかブルータス',
          'A♩あと５cmだけいざ成長.B♩つくりたいのはいい映像.C♩ホントの願いを今SAY HO',
        ],
        step: [], // 各問題のステップ数
        answer: [1,3,2,1,3], // 各問題の解答
        /* ↓↓↓ ハート位置のランダム生成 ↓↓↓ */ 
        animPos: [0,0,0,0,0],
        pos: [1,2,3,4,5], // ボタンの位置
        posX: [], // X軸のランダム
        posY: [], // Y軸のランダム
        /* ↑↑↑ ハート位置のランダム生成 ↑↑↑ */ 
        flg: {
          start: false, // スタートアニメーションのフラグ
          game: false, // プレイ中フラグ
          q: false, // 問題文表示アニメーションフラグ
          frame: false // コマ割り込みフラグ
        },
        timer: '', // ハート落下アニメーションのタイマー
        animTimer: '', // 問題文表示アニメーションのタイマー
        height: 0,
        result: false,
      }
    },
    mounted () {
      // let vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty('--vh', `${vh}px`)

      this.height = 630 //$('#game_01 .game .btns').height() * 2

      this.init()
      this.initQ()

      $('#game_01 .game .btns .btn').on('touchstart', this.onClickBtn)
      $('#game_01 .txt').on('touchstart', this.next)
      $('#game_01 .result').on('touchstart', this.resultClose)
    },
    destroyed () {
      $('#game_01 .game .btns .btn').off('touchstart', this.onClickBtn)
      $('#game_01 .txt').off('touchstart', this.next)
      $('#game_01 .result').off('touchstart', this.resultClose)
    },
    methods: {
      init() {
        this.setPos()

        this.setStep()
        this.setQuestion()
      },
      /* ----- イベントハンドラー ----- */ 
      next() {
        if(this.flg.start || this.flg.game || this.flg.frame) return

        // 設問アニメーションスキップ
        if(this.flg.q) {
          this.flg.q = !this.flg.q
          this.showQuestion()
          clearInterval(this.animTimer)
        }

        $('#game_01 .txt .next').hide()

        this.state.qCnt++
        this.setAnswer()

        switch(true) {
          case this.state.qCnt < this.step[this.state.current]:
            // 次のテキストがある場合
            this.setQuestion()
            break
          case this.state.current === 0:
            // 初回時のみアニメーションあり
            this.startAnim()
            break
          default:
            // ゲーム開始
            this.start()
            break
        }

      },
      startAnim() {
        if(this.flg.q)  {
          return
        }
        this.flg.start = !this.flg.start
        $('#game_01 .game .chara').addClass('walk')

        setTimeout(() => {
          $('#game_01 .game .chara').removeClass('walk')
          $('#game_01 .game .chara').addClass('jump')
          $('#game_01 .txt .answer').show()
          $('#game_01 .txt_wrapper .answer').show()

          this.start()
          this.flg.start = !this.flg.start
        }, 2000)
      },
      onClickBtn(e) {
        if(!this.flg.game) return

        let p = this.posX[this.pos.indexOf(this.answer[this.state.current])] // 正解のindex
        let pPosY = this.pos.indexOf(this.answer[this.state.current])

        this.flg.game = !this.flg.game
        clearInterval(this.timer)

        // 押したボタンが正解か判定
        switch(true) {
          case $(e.currentTarget).data('x') == p && this.animPos[pPosY] == 0:
            // 正解時
            this.state.current++

            if(this.state.current != 5) {
              this.showResult()
            }else {
              // 5問目
              this.result = !this.result
              this.sendResult()
            }
            break
          default:
            // 不正解時
            this.sendResult()
            break
        }
      },
      resultClose() {
        $('#game_01 .result').hide()
        $('#game_01 .main').show()

        switch(this.state.current) {
          case 3:
            this.initQ()
            this.setPos()

            $('#game_01 .game .frames').show(0, () => {
              this.flg.frame = !this.flg.frame
              setTimeout(() => {
                $('#game_01 .game .frames').hide()
                // コマ割り込み終了後に問題を表示
                this.setQuestion()
                this.flg.frame = !this.flg.frame
              }, 3000)
            })
            break
          default:
            // 1~4問目
            this.initQ()
            this.setPos()
            this.setQuestion()
            break
        }
      },
      /* ----- modules ----- */
      // ゲームスタート処理
      start() {
        this.flg.game = !this.flg.game
        this.state.qCnt = 0

        $('#game_01 .txt .q_txt').hide()
        $('#game_01 .txt .answer').show()
        $('#game_01 .game .volumes').show()

        this.timer = setInterval(() => {
          for(let i = 0; i < this.pos.length; i++) {
            this.animPos[i] = this.animPos[i] - this.height / 8 / 7.5
            $(`#game_01 .game .hearts .heart[data-num="${this.pos[i]}"]`).css({bottom: this.animPos[i]+'vw'})

            // ボタンが全て通り過ぎたらinterval終了
            if(Math.max.apply(null, this.animPos) < -16) {
              clearInterval(this.timer)
              this.sendResult()
            }
          }
        }, 500)
      },
      // 設問、選択肢を初期化
      initQ() {
        $('#game_01 .txt .title').text(`第${this.state.current + 1}問`)

        $('#game_01 .txt .answer').html('')
        $('#game_01 .txt .q_txt').html('')

        $('#game_01 .txt .answer').hide()
        $('#game_01 .txt .q_txt').show()
      },
      setStep() {
        for(let i = 0; i < this.q.length; i++) {
          this.step.push(this.q[i].length)
        }
      },
      setPos() {
        let dx = this.rand(4)
        this.pos = this.shuffle(this.pos)
        this.posX = [0,1,2,3]
        this.posY = [this.rand(4),this.rand(4),this.rand(4),this.rand(4)]

        this.posX.push(dx)
        this.posY.push(this.posY[dx] + this.rand(2) + 2)

        for(let i = 0; i < this.pos.length; i++) {
          $(`#game_01 .game .hearts .heart[data-num="${this.pos[i]}"]`).removeClass(['x1','x2','x3','x4']).addClass(`x${this.posX[i]}`)
          $(`#game_01 .game .hearts .heart[data-num="${this.pos[i]}"]`).css({bottom: (this.height + (this.posY[i] * (this.height / 8))) / 7.50+'vw'})
          this.animPos[i] = (this.height + (this.posY[i] * (this.height / 8))) / 7.50
        }
      },
      // カレントの問題文をアニメーション表示
      setQuestion() {
        const txtArea = $('#game_01 .txt_wrapper .q_txt')
        let txt = this.convertBr(this.q[this.state.current][this.state.qCnt].split(''))
        this.flg.q = !this.flg.q

        $('#game_01 .txt .q_txt').html('')

        this.animTimer = setInterval(() => {
          $(txtArea).html($(txtArea).html() + txt.shift())

          if(txt.length == 0) {
            clearInterval(this.animTimer)
            this.flg.q = !this.flg.q
            $('#game_01 .txt .next').show()
          }
        },70)
      },
      showQuestion() {
        $('#game_01 .txt_wrapper .q_txt').html(this.q[this.state.current][this.state.qCnt].replaceAll('.', '<br>'))
      },
      // カレントの選択肢をセット
      setAnswer() {
        $('#game_01 .txt_wrapper .answer').html(this.a[this.state.current].replaceAll('.', '<br>'))
      },
      // 正解画面表示
      showResult() {
        $('#game_01 .main').hide()
        $('#game_01 .result').show()
      },
      convertBr(arr) {
        for(let i = 0; i < arr.length; i++) {
          // if(arr[i] === '.') arr[i] = document.createElement('br')
          if(arr[i] === '.') arr[i] = '<br>'
        }

        return arr
      },
      // シャッフル
      shuffle(array) {
        for(var i = array.length - 1; i > 0; i--) {
            var r = Math.floor(Math.random() * (i + 1))
            var tmp = array[i]
            array[i] = array[r]
            array[r] = tmp
        }
        return array
      },
      // 乱数生成
      rand(size) {
        return Math.floor(Math.random() * size)
      },
      // ゲーム結果を送信 --- クリアの時は「true」、失敗の時は「false」-------------
      sendResult: function() {
        this.$emit('gameResult', this.result);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #game_01 {
    // height: 100vh;
    // height: calc(var(--vh, 1vh) * 100);
    width: 100%;
    height: 100%;
    position: relative;
    font-size: 3.46vw;
    letter-spacing: .1em;
    line-height: 5.06vw;
    font-family: DotGothic16,sans-serif;

    * {
      box-sizing: border-box;
    }

    .main {
      position: relative;
      height: 100%;
    }

    .game_wrapper {
      position: relative;
      width: 100%;
      // 100% - (.txtのheight + 上下margin)
      height: calc(100% - 31.32vw);

      .game {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        width: 100%;
        height: 115.73vw;
        overflow: hidden;

        .field {
          position: relative;
          width: 100%;
          height: 87.2vw;
          background: left top no-repeat;
          background-size: 100%;
          overflow: hidden;

          .hearts {
            position: relative;
            height: 84vw;

            .heart {
              position: absolute;
              bottom: 3.2vw;
              width: 14.66vw;
              height: 13.06vw;
              background: left top no-repeat;
              background-size: 100%;

              &.x0 { left: 7.06vw; }
              &.x1 { left: 30.8vw; }
              &.x2 { left: 54.52vw; }
              &.x3 { left: 78.26vw; }
            }
          }

          .btns {
            position: absolute;
            bottom: 0;
            height: 17.6vw;
            width: 100%;

            .btn {
              position: absolute;
              width: 17.6vw;
              height: 17.6vw;

              &.x1 { left: 5.6vw; }
              &.x2 { left: 29.33vw; }
              &.x3 { left: 53.06vw; }
              &.x4 { left: 76.8vw; }
            }
          }
        }

        .chara_area {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 28.53vw;

          .chara {
            position: absolute;
            bottom: 0;
            height: 100%;
            background: center bottom no-repeat;
            background-size: 100%;
          }

          .hasaka {
            width: 14.66vw;
            height: 22.53vw;
            left: -5.33vw;

            &.walk {
              animation: 1.5s steps(3) 0s 1 forwards leftToCenter;
            }

            &.jump {
              left: 31.2vw;
              animation: 2s steps(2) 0s infinite jump;
            }
          }

          .fujiwara {
            width: 15.06vw;
            height: 21.6vw;
            right: -5.33vw;

            &.walk {
              animation: 1.5s steps(3) 0s 1 forwards rightToCenter;
            }

            &.jump {
              right: 31.2vw;
              animation: 2s steps(2) 1s infinite jump;
            }
          }
        }

        .volumes {
          display: none;

          .volume {
            position: absolute;
            bottom: 0;
            width: 24.13vw;
            height: 21.86vw;
            background: left top no-repeat;
            background-size: 100%;
          }

          .left {
            left: 3.06vw;
          }

          .right {
            right: 3.06vw;
          }
        }

        .frames {
          position: absolute;
          top: 0;
          left: 0;
          display: none;
          width: 100%;
          height: 100%;

          .frame {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto 0;
            width: 100%;
            height: 71.33vw;
            
            .img {
              position: relative;
              width: 100%;
              height: 71.33vw;
              animation: .3s steps(2) 0s 2 none shake;
              background: left top no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }

    .txt_wrapper {
      position: absolute;
      bottom: 0;
      width: 100%;

      .txt {
        position: relative;
        margin: 1.73vw;
        height: 27.86vw;
        background: center top no-repeat;
        background-size: 100%;

        div {
          position: absolute;
        }

        .title {
          top: .8vw;
          // right: 0;
          // left: 0;
          margin: 0 auto;
          text-align: center;
          
          width: 100%;
          height: 3.2vw;
          color: #e50065;
        }

        .q_txt {
          top: 8.8vw;
          left: 0vw;
          right: 0;
          margin: 0 auto;
          width: 70vw;
        }

        .answer {
          top: 8.8vw;
          left: 0vw;
          right: 0;
          display: none;
          margin: 0 auto;
          width: 70vw;
          letter-spacing: 0em;
        }

        .next {
          right: 4.26vw;
          bottom: 4.26vw;
          display: none;
          width: 3.73vw;
          height: 2.8vw;
          animation: 1s step-end  0s infinite none flash;
          background: center top no-repeat;
          background-size: 100%;
        }
      }
    }

    .result {
      position: relative;
      display: none;
      height: 100%;

      div {
        position: absolute;
        background: left top no-repeat;
        background-size: 100%;
      }

      .correct {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 75.33vw;
        height: 87.06vw;

        div {
          width: 100%;
        }

        .bar {
          height: 14.53vw;

          &.top {
            top: 0;
          }
          &.bottom {
            bottom: 0;
          }
        }
        .chara {
          top: 0;
          bottom: 0;
          margin: auto 0;
          height: 51.73vw;
        } 
      }

      .next {
        position: absolute;
        right: 0;
        bottom: 4vw;
        left: 0;
        margin: 0 auto;
        width: 3.73vw;
        height: 2.8vw;
        animation: 1s step-end  0s infinite none flash;
      }
    }
  }

  @keyframes leftToCenter {
    from {
      left: -5.33vw;
    }
    to {
      left: 31.2vw;
    }
  }
  @keyframes rightToCenter {
    from {
      right: -5.33vw;
    }
    to {
      right: 31.2vw;
    }
  }
  @keyframes jump {
    from {
      bottom: 0;
    }
    to {
      bottom: 2.66vw;
    }
  }
  @keyframes flash {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes shake {
    from {
      top: -25px;
    }
    to {
      top: 25px;
    }
  }
</style>
